export const HEADERS = { headers: {
    "Authorization" : "NjI5OTQxYjE0ODYxMDAwMDc3MDA0NGVkfDAxdDh3NjZpZTM4Nzd4Mw=="
}};

export const API_MARCAS = "https://avaluauto.com/api/marcas";
export const API_MODELOS = "https://avaluauto.com/api/modelos/search?";
export const API_LINEAS = "https://avaluauto.com/api/lineas/search?";
export const API_VERSIONES = "https://avaluauto.com/api/versiones/search?";
export const API_TIPOS = "https://avaluauto.com/api/tipos_vehiculos";
export const API_LINEAS_BY_MARCA = "https://avaluauto.com/api/get_lineas_marca/search?";